export const WidgetConfigs = [
  {
    name: 'floating',
    tagName: 'inspired-floating-widget',
    importPath: './widgets/floating-widget'
  },
  {
    name: 'banner',
    tagName: 'inspired-announcement-banner',
    importPath: './widgets/banner-widget'
  },
  {
    name: 'embeddedCart',
    tagName: 'inspired-impact-offer',
    importPath: './widgets/embedded-widget'
  },
  {
    name: 'embeddedCartDrawer',
    tagName: 'inspired-impact-offer',
    importPath: './widgets/embedded-widget'
  },
  {
    name: 'embeddedProduct',
    tagName: 'inspired-impact-offer',
    importPath: './widgets/embedded-widget'
  },
  {
    name: 'progressCart',
    tagName: 'inspired-cart-progress-widget',
    importPath: './widget/cart-progress-widget'
  },
  {
    name: 'progressCartDrawer',
    tagName: 'inspired-cart-progress-widget',
    importPath: './widget/cart-progress-widget'
  }
];

export const PAID_THEME_TARGETS: { [key: number]: ThemeTarget } = {
  568: { cartPage: '.checkout-subtotal-container .checkout-buttons', cartDrawer: '.cart-drawer__footer .checkout-buttons', productPage: '.add-to-cart' }, // Symmetry
  1190: { cartPage: '.cart-order__recap .button[name="checkout"]', cartDrawer: '.cart-drawer .buy-buttons', productPage: '.buy-buttons' }, // Impact
  857: { cartPage: '.cart__page .cart__checkout-wrapper', cartDrawer: '.drawer .cart__checkout-wrapper', productPage: '.payment-buttons' }, // Impulse
  855: { cartPage: '.cart-recap button[name="checkout"]', cartDrawer: '.cart-drawer__footer .button-group', productPage: '.buy-buttons' }, // Prestige
  1657: { cartPage: '.cart button[name="checkout"]', cartDrawer: '.cart-drawer__summary', productPage: '.product-info__add-to-cart' }, // Enterprise
  868: { cartPage: '.cart__form button[name="checkout"]', cartDrawer: '#cart-drawer button[name="checkout"]', productPage: '.product__submit__buttons' }, // Broadcast
  838: { cartPage: '.cart-checkout', cartDrawer: '', productPage: '.shopify-payment-button' }, // Empire
  1399: { cartPage: '.cart__ctas', cartDrawer: '.mini-cart__footer .button-container', productPage: '.product-form__buttons' }, // Be Yours
  847: { cartPage: '.cart__footer .cart__checkout-wrapper', cartDrawer: '.drawer__footer .cart__checkout-wrapper', productPage: '.payment-buttons' }, // Motion
  2412: { cartPage: '.drawer__footer-buttons', cartDrawer: '.cart__sidebar button[name="checkout"]', productPage: '.product-form__buttons' }, // Concept
  777: { cartPage: '.cart__aside .cart__buttons', cartDrawer: '.cart-drawer .cart__buttons', productPage: '.product__submit__buttons' }, // Palo Alto
  902: { cartPage: '.cart__page .cart__checkout-wrapper', cartDrawer: '.site-header__drawer .cart__checkout-wrapper', productPage: '.block-buy-buttons' }, // Expanse
  1535: { cartPage: '[x-data="ThemeModule_CartFooter"]', cartDrawer: '[x-data="ThemeModule_CartFooter"]', productPage: '.shopify-product-form' }, // Shapes
  836: { cartPage: '#main-cart button[name="checkout"]', cartDrawer: '.cart__controls #drawer-cart', productPage: '.product-form' }, // Venue
  1621: { cartPage: '.cart__footer button[name="checkout"]', cartDrawer: '.quick-cart__footer-inner', productPage: '.product-form__controls-group' }, // Stiletto
  623: { cartPage: '.cart-page .ajax-cart__buttons', cartDrawer: '#mini-cart .ajax-cart__buttons', productPage: '.product__section--buttons' }, // Testament
  2160: { cartPage: '.cart__buttons-container', cartDrawer: '.cart-drawer__footer-info', productPage: '.product-form__controls-group--submit' }, // Honey
  606: { cartPage: '.section--cart .cart--nav', cartDrawer: '.drawer--root .cart--nav', productPage: '.product-buy-buttons--root' }, // Blockshop
  714: { cartPage: '.cart__checkout-button', cartDrawer: '.mini-cart__actions', productPage: '.product-form__payment-container' }, // Focal
  739: { cartPage: '.cart__footer__checkout button[name="checkout"]', cartDrawer: '.drawer__bottom', productPage: '.product__submit__buttons' }, // Pipeline
  871: { cartPage: '.cart-recap__checkout', cartDrawer: '.mini-cart__button-container', productPage: '.product-form__buy-buttons' }, // Warehouse
  2053: { cartPage: '.proceed-to-checkout', cartDrawer: '.cart-drawer-buttons', productPage: '.product-add-to-cart-container' }, // Vision
  1762: { cartPage: '.proceed-to-checkout', cartDrawer: '.cart-drawer-buttons', productPage: '.shopify-payment-button' }, // Reformation
  1651: { cartPage: '.cart-section #CheckOut', cartDrawer: '.sidebar__footer #ViewCart', productPage: '.product__cart-functions' }, // Local
  1826: { cartPage: '.cart-section #CheckOut', cartDrawer: '.sidebar__footer #ViewCart', productPage: '.product__cart-functions' }, // Combine
  910: { cartPage: '#main-cart-footer button[name="checkout"]', cartDrawer: '#right-drawer-slot button[name="checkout"]', productPage: '.add-to-cart-container' }, // Baseline
  801: { cartPage: '.cart .btn-wrapper-default', cartDrawer: '.ajaxcart .cart__checkout', productPage: '.paymentButtonsWrapper' }, // Flow
  732: { cartPage: '.cart button[name="checkout"]', cartDrawer: '.cart-drawer__checkout-buttons', productPage: '.product-info__add-to-cart' }, // Canopy
  1926: { cartPage: '.cart__summary-actions button[name="checkout"]', cartDrawer: '.cart-drawer__summary-actions', productPage: '.product__installments' }, // Sahara
  718: { cartPage: '.cart-buttons-container', cartDrawer: '.mini-cart-footer', productPage: '.product-add-to-cart' }, // Grid
}


// Currently all free themes have the same targets
const freeTargets: ThemeTarget = { cartPage: '.cart__footer .cart__ctas', cartDrawer: '.drawer__footer .cart__ctas', productPage: '.product-form__buttons' };
export const FREE_THEME_TARGETS: { [key: number | string]: ThemeTarget } = {
  887: freeTargets,  // Dawn
  2699: freeTargets, // Trade
  1891: freeTargets, // Spotlight
  1567: freeTargets, // Refresh
  1356: freeTargets, // Sense
  1368: freeTargets, // Craft
  1500: freeTargets, // Ride
  1841: freeTargets, // Origin
  1434: freeTargets, // Taste
  1431: freeTargets, // Studio
  1864: freeTargets, // Publisher
  1363: freeTargets, // Crave
  1499: freeTargets, // Colorblock
  // eslint-disable-next-line no-useless-computed-key
  ['test-data']: freeTargets, // Test Data (test store theme)
}

export interface ThemeTarget {
  cartPage: string,
  cartDrawer: string
  productPage: string
}
